import React from 'react'

import './fronthand_style.css';
import './fronthand_media-queries.css';


import { useEffect, useState } from 'react'

import {Login_Detail, Refferal_Detail, Refferal_SignUp} from './Data_Structure';


export default function Bnb_SignUp_Area(props) {
    
    const [Wallet_Balance, SetWallet_Balance] = useState("0.000");

    const [IsInput_Eligible, SetIsInput_Eligible] = useState(false); 
    const [value, setValue] = useState("");
    const [error, setError] = useState("");

    
    const [IsNum_Input_Eligible, SetIsNum_Input_Eligible] = useState(false); 
    const [Num_Value, SetNum_Value] = useState("");
    const [Num_Error, SetNum_Error] = useState("");

    const [IsSignUp_Btn_Disabled, SetIsSignUp_Btn_Disabled] = useState(true);

    const handleChange = (e) => {
        const val = e.target.value;
        setValue(val);
        console.log(val);

        const num = Number(val);

        if (val === "") {
            setError("");
            SetIsNum_Input_Eligible(false);
            SetIsSignUp_Btn_Disabled(true);
        } 
        else if(val === " " || val === "  " || val === "   " || val === "    " || val === "     " || val === "      " || val === "       " || val === "        " || val === "         ") {
            setError(" InValid UserName Type.");
            SetIsNum_Input_Eligible(false);
            SetIsSignUp_Btn_Disabled(true);
        }
        else {
            setError("");
            SetIsNum_Input_Eligible(true);
            SetIsSignUp_Btn_Disabled(true);
        }
    };

    const Num_handleChange = (e) => {
        const val = e.target.value;
        SetNum_Value(val);
        console.log(val);

        const num = Number(val);

        if (num === "") {
            SetNum_Error("");
            SetIsSignUp_Btn_Disabled(true);
        } else if (num < 20 || num > 110) {
            SetNum_Error("Value must be equal or between 20 and 110");
            SetIsSignUp_Btn_Disabled(true);
        } else {
            SetNum_Error("");
            SetIsSignUp_Btn_Disabled(false)
        }
    };


    const [Upline_ID, SetUpline_ID] = useState('');

    const open = async() => {
        
        try {
            props.connect({ connector: props.injected() });

            // props.connect({ 
            //     connector: props.injected({
            //         target() {
            //             // 1. Look for TokenPocket inside a multi-provider extension environment
            //             const provider = window.ethereum?.providers?.find((p) => p.isTokenPocket) 
            //             || window.ethereum?.isTokenPocket ? window.ethereum : undefined;

            //             return {
            //                 id: 'tokenPocket',
            //                 name: 'TokenPocket',
            //                 provider: provider,
            //             };
            //         },
            //     })
            // });
            // props.connect({ 
            //     connector: props.injected({
            //         options: {
            //             name: 'TokenPocket',
            //             getProvider: () => {
            //                 if (typeof window === 'undefined') return undefined;
                            
            //                 return window.ethereum?.providers?.find((p) => p.isTokenPocket) 
            //                 || (window.ethereum?.isTokenPocket ? window.ethereum : undefined);
            //             }
            //         }
            //     })
            // });
        }
        catch(error) {
            console.log("Signed In Error");
            console.log(error);
        }
    } 

    const Activate_ID = async() => {
        try {
            const username_ = value;
            const usdt_val_ = Num_Value;
            console.log("username_: ");
            console.log(username_);
            console.log("usdt_val_: ");
            console.log(usdt_val_);

            // if(username_ === '' || username_ === ' ') {
            //     props.showAlert("Please Put Valid UserName!...", "warning", false);                                
            // }
            // else {                
                if (props.address === undefined || props.address === "" || props.address === " ") {
                    console.log("Address : " + props.address);
                }
                else {
                    console.log("Add: " + props.address);
                    Refferal_SignUp(props.address, props.param.id, username_, usdt_val_, props.showAlert, props.SetLoadingModal);
                }
            // }
        }       
        catch(error) {
            console.log(error);
        }
    }
    
    useEffect(() => {
        const Check_Refferal = async() => {
            if (props.param.id !== '') {
                console.log(props.param.id);
                         
                // props.SetLoadingModal(true, true);
                props.showAlert("Sponser Id is " + props.param.id, "success", true);
                Refferal_Detail(props.param.id, SetUpline_ID, props.showAlert, SetIsInput_Eligible, props.address, SetWallet_Balance, open);
                console.log("IsInput_Eligible: "+ IsInput_Eligible);
                
            }
            else {}      
        }
        Check_Refferal();
    }, [document.URL, props.address]);
    

    return (
        <>
            <div class="signup-content">
                <section>
                    <div class="f-signup-header f-font-color">
                        <h3>Welcome</h3>
                    </div> 
                    <div class="f-card-signup">
                        <h3 class="f-signup-title">Signup with any Dapp Wallet</h3>
                        <div class="form-group">
                            <label class="form-label" for="fullname"></label>
                            <input class="form-input" type="text" id="fullname" name="fullname" placeholder="Enter User Name" maxlength="12" value={value} onChange={handleChange} required disabled={IsInput_Eligible===false}/>
                            {error && <p style={{ color: "red" }}>{error}</p>}
                        </div>
                        <div class="f-card-wallet f-font-color">
                            <div class="f-card-head"><h3>Wallet Balance</h3></div>  
                            <div class="f-card-funds">
                                <span>$</span>
                                <span>{Wallet_Balance}</span>
                            </div>
                        </div>
                        <div class="f-card-wallet f-font-color">
                            <div class="f-card-head"><h3>TopUp Amount</h3></div>   
                            <div class="f-card-funds">
                                <h5>Min = 20 $</h5>
                                <h5>Min = 110 $</h5>
                                <div class="pack">
                                    <label for="package"></label>
                                    <input class="form-input" type="number" id="number" name="number" placeholder="Enter Amount" maxlength="3" value={Num_Value} onChange={Num_handleChange} required disabled={IsNum_Input_Eligible===false}/>
                                </div>   
                            </div>
                        </div>                        
                        {Num_Error && <p style={{ color: "red" }}>{Num_Error}</p>}  

                        <div class="f-card-signup-btn">  
                            {
                                IsSignUp_Btn_Disabled === true ? (
                                    <>                          
                                        <button style={{background: 'grey'}}>Sign Up<span></span></button>                                                   
                                    </>
                                ) : IsSignUp_Btn_Disabled === false ? (
                                    <>                                     
                                        <button onClick={() => {Activate_ID();}}>Sign Up<span></span></button>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                        </div> 
                    </div> 
                </section>
            </div>
        </>
    );

    {/* return (
        <div class="signup-content">
            <section>
    //             <div class="f-signup-header f-font-color">
    //                 <h3>Welcome</h3>
    //             </div> 
    //             <div class="f-card-signup">
    //                 <h3 class="f-signup-title">Signup with any Dapp Wallet</h3>
    //                 <div class="form-group">
    //                     <label class="form-label" for="fullname"></label>
    //                     <input class="form-input" type="text" id="fullname" value={value} onChange={handleChange}  name="fullname" placeholder="Enter User Name" maxlength="12" required  disabled={IsInput_Eligible===false}/>
    //                 </div>
    //                 <div class="f-card-wallet f-font-color">
    //                     <div class="f-card-head"><h3>Wallet Balance</h3></div>  
    //                     <div class="f-card-funds">
    //                         <span>$</span>
    //                         <span>{Wallet_Balance}</span>
    //                     </div>
    //                 </div>
    //                 <div class="f-card-wallet f-font-color">
    //                     <div class="f-card-head"><h3>TopUp Amount</h3></div>   
    //                     <div class="f-card-funds">
    //                         <span>$</span>
    //                         <span>100.000</span>
    //                     </div>
    //                 </div>
    //                 <div class="f-card-signup-btn">
    //                     <button onClick={() => {Activate_ID()}}>Sign Up<span class=""></span></button>
    //                 </div>
    //             </div> 
            </section>
        </div>
    ); */}
}

// export default function Bnb_SignUp_Area(props) {
    
//     const [IsInput_Eligible, SetIsInput_Eligible] = useState(false); 

//     const [value, setValue] = useState("");
//     const [error, setError] = useState("");

//     const handleChange = (e) => {
//         const val = e.target.value;
//         setValue(val);

//         const num = Number(val);

//         if (val === "") {
//             setError("");
//         } else if (num < 20 || num > 1000) {
//             setError("Value must be equal or between 20 and 1000");
//         } else {
//             setError("");
//         }
//     };


//     const [Upline_ID, SetUpline_ID] = useState('');

//     const open = async() => {
//         props.connect({ connector: props.injected() });
//     } 

//     const Activate_Package = async() => {
//         try {
//             const num = Number(value);
//             if(num > 19 && num < 1001) {
                
//                 if (props.address === undefined || props.address === "" || props.address === " ") {
//                     console.log("Address : " + props.address);
//                 }
//                 else {
//                     console.log("Add: " + props.address);
//                     Refferal_SignUp(props.address, props.param.id, value, props.showAlert, props.SetLoadingModal);
//                 }
//             }
//             else {
//                 props.showAlert("Please Put Valid Amount!...", "warning", false);
//             }
//         }       
//         catch(error) {
//             console.log(error);
//         }
//     }
    
//     useEffect(() => {
//         const Check_Refferal = async() => {
//             if (props.param.id !== '') {
//                 console.log(props.param.id);
//                 let is_limit_exceeded = await GetIs_Limit_Exceeded();
                
//                 if(is_limit_exceeded === true) {
//                     props.showAlert("Roi ID Limit Exceeded!", "danger", true);
//                     SetIsInput_Eligible(false);
//                 }                
//                 else {                
//                     // props.SetLoadingModal(true, true);
//                     props.showAlert("Sponser Id is " + props.param.id, "success", true);
//                     Refferal_Detail(props.param.id, SetUpline_ID, props.showAlert, SetIsInput_Eligible, open);
//                     console.log("IsInput_Eligible: "+ IsInput_Eligible);
//                 }
                
//             }
//             else {}      
//         }
//         Check_Refferal();
//     }, [document.URL]);
    
//     return (
//         <div class="main-content-f"> 
//             {/*<!--===================-->
//             <!--Package--Activation--Card--Aria-->
//             <!--===================-->*/}
//             <section id="Activation" class="back-grid-dark">
//                 <div class="heading">
//                     <h1>Package Activation</h1>
//                 </div>
//                 <div class="dash-Pack">
//                     <div class="card-activation">
//                         <div class="card-body">
//                             <span>TradeX Package</span>
//                             <h2> Min = 20$</h2>
//                             <h2> Max = 1000$</h2>
//                             <div class="pack">
//                                 <input type="number" name="package" value={value} onChange={handleChange} placeholder="Enter here" disabled={IsInput_Eligible===false}/>
//                                 {error && <p style={{ color: "red" }}>{error}</p>}
                                                                  
//                                 <label for="package"></label>
//                             </div> 
//                         </div>
//                         <div class="card-btn" onClick={() => {Activate_Package()}}>
//                             <a class="activation-btn">Activate</a>  
//                         </div>
//                     </div>                
//                 </div>
//             </section>
//         </div>
//     );
// }
